// extracted by mini-css-extract-plugin
export var csatScore = "_nm-5";
export var header = "_nm-1";
export var panelWrapper = "_nm-2";
export var postPreview = "_nm-3";
export var rightContent = "_nm-0";
export var wrappingText = "_nm-4";